module.exports = __webpack_public_path__ + "img/GI0003.cd33551.jpg";